module.exports = __webpack_public_path__ + "static/img/slide2_ban.8b13142.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/slide2_ban.png
// module id = o6Qw
// module chunks = 1